import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Button as ButtonM,
  Dialog,
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import { Button } from 'react-admin'
import { useStyles } from '../styles'
import VerticalTabs from './VerticalTabs'

export const Votes = (props) => {
  const { record, ag, isResolutionOpen, setIsChanged } = props
  const [show, setShow] = useState(show_var)
  const classes = useStyles()
  const refresh = () => {
    setIsChanged((prev) => {
      let newVal = new Date().getTime()
      return newVal
    })
  }
  //When we use DeleteVote button, we make a refresh, but we want this
  //modal to persist.
  //So each time we delete a vote successfully, we update window["vote_modal_id"] with this component computed id.
  //When this component reloads, if its computed id matches window["vote_modal_id"],
  //we know we must open this modal.
  var show_var = false
  const id_var = 'votes_res_' + record.id

  if (window['vote_modal_id'] === id_var) {
    show_var = true
  }

  const toggleDialog = () => {
    setShow(!show)
  }

  if (!record) return null
  if (record.majorite_bo == 'sans vote') return null
  // if (record.subs.length > 0) return null // - [x] Si la resolution est a  voter on doit avoir Button gérer les vote

  return (
    <Grid item xs={12}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.actionButton}
        size="normal"
        label={props.label ? props.label : 'Votes'}
        onClick={toggleDialog}
      />

      <Dialog
        open={show}
        onClose={toggleDialog}
        PaperProps={{
          style: {
            minWidth: '80%',
            minHeight: '-webkit-fill-available',
          },
        }}
      >
        <DialogTitle>
          <Grid container justifyContent="space-between">
            <Grid item>Gestion des votes</Grid>
            <Grid item>
              <ButtonM
                variant="contained"
                color="primary"
                onClick={toggleDialog}
              >
                Fermer
              </ButtonM>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {/* {VerticalTabs} */}

          <VerticalTabs
            id_var={id_var}
            ag={ag}
            record={record}
            isResolutionOpen={isResolutionOpen}
            refresh={refresh}
          />
        </DialogContent>
      </Dialog>
    </Grid>
  )
}
export default Votes
